import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=9fc8d6f2&scoped=true&"
import script from "./HomeNews.vue?vue&type=script&lang=ts&"
export * from "./HomeNews.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=9fc8d6f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc8d6f2",
  null
  
)

export default component.exports